module.exports = __webpack_public_path__ + "static/media/bfile-handshake.1cc80de2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-handshake.svg
// module id = 1016
// module chunks = 0